export const AVATAR_COLORS = ['#623CEA'];
export const AVATAR_OPACITY = 1;
